import Cookies from 'jscookie';

var counter = 0,
  //AnalyticsAL = window.AnalayticsAL,
  setWebEvent = function (toolName, eventName, eventData) {
    if (Cookies.get('cookieAccepted') !== 'true') {
      //console.info("Suppressed: " + toolName + " [" + eventName + "]", eventData);
    } else {
      try {
        window.AnalyticsAL.setWebEvent('payload', { event: eventName, payload: eventData });
        console.info('ADOBEDTM: ' + toolName + ' ' + eventName, eventData); // eslint-disable-line no-console
      } catch (e) {
        console.error('Could not call AnalyticsAL.setWebEvent for ' + eventName, eventData); // eslint-disable-line no-console
      }
    }
  },
  checkAnalyticsAL = function (toolName, hash) {
    if (counter > 9) return;
    if (typeof AnalyticsAL == 'undefined' || !window.AnalyticsAL)
      setTimeout(function () {
        counter++;
        checkAnalyticsAL(toolName, hash);
      }, 100);
    else {
      // If for some reason we do not get AnalyticsAL
      if (typeof AnalyticsAL === 'undefined' || !window.AnalyticsAL) {
        console.error('AnalyticsAL was not loaded'); // eslint-disable-line no-console
        window.AnalyticsAL = {
          setWebEvent: function () {},
          webData: {},
        };
      }

      // AnalyticsAL.webData should come from Adobe DTM
      if (!window.AnalyticsAL.webData) window.AnalyticsAL.webData = {};
      window.AnalyticsAL.webData.toolName = toolName;
      if (!window.AnalyticsAL.setWebEvent)
        window.AnalyticsAL.setWebEvent = function () {
          console.error('setWebEvent is');
        }; // eslint-disable-line no-console
      // Track session start
      window.AnalyticsAL.setWebEvent('toolStart', { toolName: toolName });
      console.info('ADOBEDTM: ' + toolName + ' session start'); // eslint-disable-line no-console
      setWebEvent(toolName, 'hashAtStart', hash);
    }
  };

export default {
  setAnalyticsAL: function (toolName) {
    checkAnalyticsAL(toolName, location.hash);
  },
  setWebEvent: function (toolName, eventName, eventData) {
    setWebEvent(toolName, eventName, eventData);
  },
};
